// extracted by mini-css-extract-plugin
export var actions = "_g0-g";
export var benefitCard = "_g0-b";
export var benefitIcon = "_g0-d";
export var benefitLabel = "_g0-f";
export var benefits = "_g0-a";
export var benefitsSection = "_g0-8";
export var bodyText = "_g0-7";
export var closeButton = "_g0-2";
export var content = "_g0-3";
export var eyebrow = "_g0-4";
export var heading = "_g0-5";
export var image = "_g0-i";
export var imagePanel = "_g0-h";
export var modal = "_g0-0";
export var offerCard = "_g0-c";
export var offerIcon = "_g0-e";
export var sectionLabel = "_g0-9";
export var shell = "_g0-1";
export var title = "_g0-6";